import React from 'react';
import NotificationCard from '../../components/NotificationCard';
import MainTitle from '../../components/MainTitle';
import EmptyState from '../../components/EmptyState';
import { isMobile } from 'react-device-detect';
import './NotificationsClient.scss';
import { useHistory } from "react-router-dom";
import Banner from '../../components/Banners/Banner';
import { connect } from 'react-redux';

const imageNotif = '/img/empty-state/notifications.svg';
const today = new Date('December 17, 1995 03:24:00');


const notificationsList = [
  /* {
    id: 1,
    name: 'Contacta Abogado',
    summary: 'Te da la bienvenida',
    description:
      'Ponemos a tu disposición un amplio directorio de abogados que pueden ayudarte.',
    date: today,
    type: 'internal',
    read: true
  },
  {
    id: 2,
    name: 'Contacta Abogado',
    summary: 'Te invita',
    description: 'Contamos con nuevos artículos que pueden ser de tu interés.',
    date: today,
    type: 'internal',
  },
  {
    id: 3,
    name: 'Lic. Emilio Lozoya',
    summary: 'Te ha contactado',
    description:
      'Estimado Usuario Cliente, te invito a realizar una recomendación de mis servicios.',
    date: today,
    type: 'contact',
    image: 'https://cdn.ameriprisecontent.com/cds/alwp/advisor/adam.r.peters/adam-peters_c9ba7_227x235.jpg',
  },
  {
    id: 4,
    name: 'Contacta Abogado',
    summary: 'Te recomienda',
    description: 'Artículos especializados en derecho laboral.',
    date: today,
    type: 'internal',
  }, */
];

const NotificationsContainer = ({pagination, notificationsLaw}) => {
  const history = useHistory();
  if (true) {
    return (
      <EmptyState
        title="Estamos atentos a notificarte de inmediato....."
        subtitle="En cuanto tengas una respuesta o te contacten por primera vez, nosotros te avisaremos al instante."
        img={imageNotif}
        handleClick={() => history.push('/busqueda')}
        callToAction="Continuar navegando"
      />
    );
  }
  return (
    <div className="notificationsClient">
      <div className="notificationsClient-title">
        <MainTitle title="Notificaciones" />
      </div>
      <div className="notificationsClient-content">
        <main className="notificationsClient-main">
                {pagination.data &&
                    pagination.data.length &&
                    pagination.data.map((notification) => {
                      return (
                        <div key={notification.uid} style={{ maxWidth: 824 }}>
                          <NotificationCard
                            elevation={1}
                            square={false}
                            notification={notification}
                            notificationsLaw={pagination.data }
                            sender={notification.messageNotification.title}
                            type={'notification.type'}
                            description={
                              <>

                                {notification.messageNotification.instruction}
                                <br />
                                {notification.messageNotification.text}
                              </>
                            }
                            uidLawyer={notification.clienteUid}
                            date={notification.createdAt._seconds}
                            featured={notification.featured}
                            read={notification.read}
                            mediaWidth={isMobile ? 32 : 92}
                            mediaHeight={isMobile ? 32 : 92}
                            mediaMargin={isMobile ? '0 8px 0 0' : '0 16px 0 0'}
                            titleFontSize={isMobile ? 16 : 18}
                            descriptionFontSize={isMobile ? 12 : 14}
                            footerFontSize={isMobile ? 10 : 12}
                            featuredPositionRight={isMobile ? 16 : 20}
                            optionsButtonMargin={isMobile ? '10px 0 0' : '10px 0 0'}
                            cardMargin={isMobile ? 0 : '0 0 8px'}
                            cardPadding={isMobile ? 12 : 16}
                            descriptionMargin={isMobile ? '0 0 8px' : '4px 0'}
                            notificationUserType={'notificationsClient'}
                          />
                          
                        </div>
                      );
                    })}
        </main>
        <aside className="notificationsClient-aside">
          <Banner forClient/>
        </aside>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  /*  formValues: state.formValues, */
  pagination: state.authClient.notificationsPageLoad,
  notificationsLaw: state.authClient.notificationsLaw
  ,
  /* imgProfile: state.authClient.imgProfile, */
});



export default connect(mapStateToProps, null)(NotificationsContainer);
